(function () {
  'use strict';

  var BREAKPOINT = 1024;

  var state = {
    scrolled:    false,  // true when scrollY > 0
    atcPosition: 'below' // 'below' | 'visible' | 'above'
  };

  var els       = { controller: null, atc: null, icons: null };
  var observers = { atc: null };
  var sentinels = { atc: null };
  var spacers   = { controller: null, atc: null };
  var spacerH   = { controller: 0 }; // stored height for smooth un-sticky
  var rafId     = null;
  var ctrlUnsticking  = false; // true while un-sticky animation is in progress
  var unstickCancel   = null;  // call to abort a pending unstick
  var atcUnsticking   = false; // true while ATC un-sticky animation is in progress
  var atcUnstickCancel = null; // call to abort a pending ATC unstick
  var obsDebounceId   = null;  // debounce timer for IntersectionObserver callback
  var obsBlackoutId   = null;  // timer: ignore observer while spacer is collapsing

  function isMobile() {
    return window.innerWidth < BREAKPOINT;
  }

  function insertSentinel(refEl) {
    var s = document.createElement('div');
    s.style.cssText = 'height:1px;overflow:hidden;visibility:hidden;pointer-events:none;margin:0;padding:0;border:0;';
    s.setAttribute('aria-hidden', 'true');
    refEl.parentNode.insertBefore(s, refEl);
    return s;
  }

  // Controller spacer: insert at full height then collapse to 0 so the gap fills smoothly.
  // While collapsing the ATC shifts up and may briefly cross the viewport edge — blind the
  // observer for the duration of the CSS transition so that transient signal is ignored.
  function ensureControllerSpacer(el) {
    if (spacers.controller) return;
    var h = el.offsetHeight;
    spacerH.controller = h;
    var s = document.createElement('div');
    s.style.cssText = 'height:' + h + 'px;margin:0;padding:0;border:0;pointer-events:none;overflow:hidden;transition:height 0.3s ease;';
    s.setAttribute('aria-hidden', 'true');
    el.parentNode.insertBefore(s, el);
    spacers.controller = s;
    // Two rAFs: let the browser paint the initial height before starting the collapse
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (spacers.controller === s) {
          s.style.height = '0';
          // Blind the observer for the collapse duration (300ms) + a small buffer
          clearTimeout(obsBlackoutId);
          obsBlackoutId = setTimeout(function () { obsBlackoutId = null; }, 380);
        }
      });
    });
  }

  // Un-sticky controller: expand spacer back to full height, then in the same JS frame
  // remove sticky class + spacer so the controller refills the slot without a layout jump.
  function unstickController(onDone) {
    if (unstickCancel) { unstickCancel(); unstickCancel = null; }

    var ctrl = els.controller;
    var sp   = spacers.controller;

    if (!sp || spacerH.controller === 0) {
      ctrl.classList.remove('luggage-drop-controller--sticky');
      if (els.icons) els.icons.classList.remove('luggage-drop-hero__icons--sticky');
      removeSpacer('controller');
      if (onDone) onDone();
      return;
    }

    // Trigger slide-out animation on controller and icons
    ctrl.classList.add('luggage-drop-controller--unsticking');
    if (els.icons) els.icons.classList.add('luggage-drop-hero__icons--unsticking');

    // Expand spacer back in sync with the slide-out (same 0.3s duration)
    sp.style.height = spacerH.controller + 'px';

    var done      = false;
    var timeoutId = null;

    function finish() {
      if (done) return;
      done      = true;
      unstickCancel = null;
      clearTimeout(timeoutId);
      ctrl.removeEventListener('animationend', finish);
      // Remove sticky + unsticking classes and spacer in the same frame
      ctrl.classList.remove('luggage-drop-controller--sticky');
      ctrl.classList.remove('luggage-drop-controller--unsticking');
      if (els.icons) {
        els.icons.classList.remove('luggage-drop-hero__icons--sticky');
        els.icons.classList.remove('luggage-drop-hero__icons--unsticking');
      }
      if (sp.parentNode) sp.parentNode.removeChild(sp);
      spacers.controller = null;
      if (onDone) onDone();
    }

    unstickCancel = function () {
      done = true;
      clearTimeout(timeoutId);
      ctrl.removeEventListener('animationend', finish);
      ctrl.classList.remove('luggage-drop-controller--unsticking');
      if (els.icons) els.icons.classList.remove('luggage-drop-hero__icons--unsticking');
      unstickCancel = null;
    };

    ctrl.addEventListener('animationend', finish);
    timeoutId = setTimeout(finish, 400); // fallback if animationend doesn't fire
  }

  function unstickAtc(onDone) {
    if (atcUnstickCancel) { atcUnstickCancel(); atcUnstickCancel = null; }

    var atc = els.atc;
    atc.classList.add('luggage-drop-buy-buttons--unsticking');

    var done      = false;
    var timeoutId = null;

    function finish() {
      if (done) return;
      done           = true;
      atcUnstickCancel = null;
      clearTimeout(timeoutId);
      atc.removeEventListener('animationend', finish);
      atc.classList.remove('luggage-drop-buy-buttons--sticky');
      atc.classList.remove('luggage-drop-buy-buttons--unsticking');
      removeSpacer('atc');
      if (onDone) onDone();
    }

    atcUnstickCancel = function () {
      done = true;
      clearTimeout(timeoutId);
      atc.removeEventListener('animationend', finish);
      atc.classList.remove('luggage-drop-buy-buttons--unsticking');
      atcUnstickCancel = null;
    };

    atc.addEventListener('animationend', finish);
    timeoutId = setTimeout(finish, 400);
  }

  // ATC spacer: simple static spacer (no collapse animation needed for ATC)
  function ensureSpacer(el, key) {
    if (spacers[key]) return;
    var s = document.createElement('div');
    s.style.cssText = 'height:' + el.offsetHeight + 'px;margin:0;padding:0;border:0;pointer-events:none;';
    s.setAttribute('aria-hidden', 'true');
    el.parentNode.insertBefore(s, el);
    spacers[key] = s;
  }

  function removeSpacer(key) {
    if (spacers[key] && spacers[key].parentNode) {
      spacers[key].parentNode.removeChild(spacers[key]);
    }
    spacers[key] = null;
  }

  function applyState() {
    var ctrl = els.controller;
    var atc  = els.atc;
    if (!ctrl || !atc) return;

    // Controller: sticky as soon as scrolled, while ATC is not yet in view
    var wantCtrlSticky = isMobile() && state.scrolled && state.atcPosition === 'below';
    // ATC: sticky once scrolled past it
    var wantAtcSticky  = isMobile() && state.atcPosition === 'above';

    if (wantCtrlSticky && !ctrl.classList.contains('luggage-drop-controller--sticky') && !ctrlUnsticking) {
      ensureControllerSpacer(ctrl);
      ctrl.classList.add('luggage-drop-controller--sticky');
      if (els.icons) els.icons.classList.add('luggage-drop-hero__icons--sticky');
    } else if (!wantCtrlSticky && ctrl.classList.contains('luggage-drop-controller--sticky') && !ctrlUnsticking) {
      ctrlUnsticking = true;
      unstickController(function () {
        ctrlUnsticking = false;
        applyState(); // re-evaluate in case state changed during animation
      });
    }

    if (wantAtcSticky && !atc.classList.contains('luggage-drop-buy-buttons--sticky') && !atcUnsticking) {
      if (atcUnstickCancel) { atcUnstickCancel(); atcUnstickCancel = null; }
      ensureSpacer(atc, 'atc');
      atc.classList.add('luggage-drop-buy-buttons--sticky');
    } else if (!wantAtcSticky && atc.classList.contains('luggage-drop-buy-buttons--sticky') && !atcUnsticking) {
      atcUnsticking = true;
      unstickAtc(function () {
        atcUnsticking = false;
        applyState();
      });
    }
  }

  function onScroll() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      var scrolled = window.scrollY > 0;
      if (scrolled !== state.scrolled) {
        state.scrolled = scrolled;
        applyState();
      }
    });
  }

  function disconnect() {
    if (unstickCancel) { unstickCancel(); unstickCancel = null; }
    if (atcUnstickCancel) { atcUnstickCancel(); atcUnstickCancel = null; }
    clearTimeout(obsDebounceId); obsDebounceId = null;
    clearTimeout(obsBlackoutId); obsBlackoutId = null;
    ctrlUnsticking = false;
    atcUnsticking  = false;
    window.removeEventListener('scroll', onScroll);
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    if (observers.atc) { observers.atc.disconnect(); observers.atc = null; }
    if (sentinels.atc && sentinels.atc.parentNode) {
      sentinels.atc.parentNode.removeChild(sentinels.atc);
      sentinels.atc = null;
    }
    removeSpacer('controller');
    removeSpacer('atc');
    if (els.icons) els.icons.classList.remove('luggage-drop-hero__icons--sticky');
  }

  function connect() {
    disconnect();

    sentinels.atc = insertSentinel(els.atc);

    observers.atc = new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      clearTimeout(obsDebounceId);
      obsDebounceId = setTimeout(function () {
        // Ignore callbacks while the controller spacer is collapsing — the ATC shifts
        // upward during the CSS transition and produces a false "visible" reading.
        if (obsBlackoutId) return;
        if (entry.isIntersecting) {
          state.atcPosition = 'visible';
        } else {
          state.atcPosition = entry.boundingClientRect.top < 0 ? 'above' : 'below';
        }
        applyState();
      }, 60);
    }, { threshold: 0 });

    observers.atc.observe(sentinels.atc);
    window.addEventListener('scroll', onScroll, { passive: true });

    // Evaluate immediately for current scroll position
    state.scrolled = window.scrollY > 0;
    applyState();
  }

  function init() {
    els.controller = document.querySelector('.luggage-drop-controller');
    els.atc        = document.querySelector('[data-role="buy-buttons"]');
    els.icons      = document.querySelector('.luggage-drop-hero__icons');
    if (!els.controller || !els.atc) return;

    ctrlUnsticking = false;
    atcUnsticking  = false;
    disconnect();
    state.scrolled    = false;
    state.atcPosition = 'below';
    els.controller.classList.remove('luggage-drop-controller--sticky');
    els.atc.classList.remove('luggage-drop-buy-buttons--sticky');
    if (els.icons) els.icons.classList.remove('luggage-drop-hero__icons--sticky');

    if (isMobile()) connect();
  }

  document.addEventListener('ldrop:swap-complete', init);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (isMobile()) {
        if (!observers.atc) connect();
      } else {
        ctrlUnsticking = false;
        disconnect();
        if (els.controller) els.controller.classList.remove('luggage-drop-controller--sticky');
        if (els.atc)        els.atc.classList.remove('luggage-drop-buy-buttons--sticky');
      }
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
